export enum Panel {
    Account = 1,
    Notification = 2,
    Skills = 3,
    Experience = 4,
}
export interface IMenumPanelItem {
    id: number;
    type: Panel;
    svgIcon?: string;
    iconClass?: string;
    title: string;
    description: string;
    order?: number;
}
